/**
 * Calculates the number of stops in a flight by examining segments and legs
 *
 *
 * @param {Object} flight - The flight object containing flight details (inside of snap-services/v2/hotels/list)
 * @returns {number} The number of stops, or 0 if no stops
 */
export const calculateFlightStops = flight => {
  // Handle flightDetails structure (like in aaFlights/nonAAFlights)
  if (flight?.flightDetails?.segments) {
    return (
      flight.flightDetails.segments.reduce(
        (totalLegs, segment) => totalLegs + (segment?.legs?.length || 0),
        0
      ) - 1
    );
  }

  // Handle direct segments structure (fallback)
  if (flight?.segments) {
    return (
      flight.segments.reduce(
        (totalLegs, segment) => totalLegs + (segment?.legs?.length || 0),
        0
      ) - 1
    );
  }

  // Fallback to original logic for flights without segments
  // If flight has legs property that's a number, use it
  if (typeof flight?.legs === 'number') {
    return flight.legs;
  }

  // If flight has numberOfStops, use it (but only if segments logic didn't find anything)
  if (typeof flight?.numberOfStops === 'number') {
    return flight.numberOfStops;
  }

  // Default to 0 (non-stop)
  return 0;
};

// Legacy alias for backward compatibility
export const getStops = calculateFlightStops;
export const getStops_v4 = calculateFlightStops;
export const calculateStops = calculateFlightStops;
